/** Drobiazgi wspolne dla widoku mapy i tabeli atrybutow. */

/** Ucieczka do wstawiania tekstu w innerHTML. */
export const esc = (s: string) =>
  String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]!))

export const nf = new Intl.NumberFormat('pl-PL')

/** Polskie liczebniki: 1 obiekt, 2 obiekty, 5 obiektow. */
const PL_RULES = new Intl.PluralRules('pl-PL')

export const OBIEKT = { one: 'obiekt', few: 'obiekty', many: 'obiektów', other: 'obiektu' }

export function plural(n: number, forms: Record<string, string>): string {
  return `${nf.format(n)} ${forms[PL_RULES.select(n)] ?? forms.many}`
}

/** Zapis do localStorage, ktory nie wywraca sie w trybie prywatnym. */
export function store(key: string, value: string) {
  try { localStorage.setItem(key, value) } catch { /* tryb prywatny przegladarki */ }
}

export function restore(key: string): string | null {
  try { return localStorage.getItem(key) } catch { return null }
}

/**
 * To samo, ale na czas jednej karty przegladarki.
 *
 * Dla stanu widoku projektu: powrot z listy ma zastac mape tam, gdzie zostala,
 * ale nowa karta (albo jutrzejsza sesja) ma zaczac od zasiegu danych - inaczej
 * projekt otwierany po tygodniu wita uzytkownika przypadkowym wycinkiem.
 */
export function storeSession(key: string, value: string) {
  try { sessionStorage.setItem(key, value) } catch { /* tryb prywatny przegladarki */ }
}

export function restoreSession(key: string): string | null {
  try { return sessionStorage.getItem(key) } catch { return null }
}
